export type BlockingOffer = {
  offerId: string;
  campaignId: string;
  campaignName: string;
  status: string;
};

// any type is necessary here
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getBlockingOffersFromError = (error: any): BlockingOffer[] =>
  error?.graphQLErrors?.[0]?.extensions?.response?.blockingOffers || [];
